import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Navigate } from 'react-router-dom'
import { featureFlags } from '../config/featureFlags'
import { HrcConnectSectionContent } from '../features/hrc/components/HrcConnectSection'
import { useConnectSubjects } from '../features/hrc/hooks/useConnectSubjects'

/** Reusable records connection and management surface. */
const ConnectMedicalRecords: React.FC = () => {
  const { load, refresh } = useConnectSubjects()

  if (!featureFlags.enableFastenConnect || (load.phase === 'ready' && load.subjects.length === 0)) {
    return <Navigate replace to="/home" />
  }

  return (
    <div className="mx-auto w-full max-w-[900px] pb-10">
      <h1 className="sr-only">
        <FormattedMessage id="healthRecords.connectPage.title" />
      </h1>
      <HrcConnectSectionContent load={load} refresh={refresh} />
    </div>
  )
}

export default ConnectMedicalRecords
